import { useLocation, useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/app';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import OrdersPage from '../Orders';
import PaymentsPage from '../Payments';

/**
 * «Заказы и платежи» — один пункт меню, две вкладки.
 * Вкладка = адрес: /orders → «Заказы», /payments → «Платежи» (старые ссылки продолжают работать).
 */
type Tab = 'orders' | 'payments';

export default function OrdersPaymentsPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const tab: Tab = pathname.startsWith('/payments') ? 'payments' : 'orders';

  return (
    <Tabs
      value={tab}
      onValueChange={(v) => navigate(v === 'payments' ? '/payments' : '/orders')}
      className="flex flex-col gap-5"
    >
      <PageHeader
        title="Заказы и платежи"
        subtitle={tab === 'orders' ? 'Заказы тарифов и их статусы' : 'Платёжные транзакции провайдеров'}
        actions={
          <TabsList aria-label="Раздел">
            <TabsTrigger value="orders">Заказы</TabsTrigger>
            <TabsTrigger value="payments">Платежи</TabsTrigger>
          </TabsList>
        }
      />
      <TabsContent value="orders" className="mt-0">
        <OrdersPage embedded />
      </TabsContent>
      <TabsContent value="payments" className="mt-0">
        <PaymentsPage embedded />
      </TabsContent>
    </Tabs>
  );
}
